const KEY_TS = 'sw:lastReloadAt';
const KEY_BUILD = 'sw:lastReloadBuild';

/**
 * Безопасный единоразовый reload страницы с TTL-дедупликацией.
 * Если с последнего reload прошло < ttlMs — пропускаем.
 * Если передан build и он совпадает с предыдущим в пределах TTL — тоже пропускаем.
 */
export function safeReloadOnce(
  reason: string,
  build: string | null = null,
  ttlMs = 60_000
) {
  try {
    const now = Date.now();
    const lastTs = Number(sessionStorage.getItem(KEY_TS) || '0');
    const lastBuild = sessionStorage.getItem(KEY_BUILD) || null;

    const withinTtl = lastTs && now - lastTs < ttlMs;
    const sameBuild = build && lastBuild && build === lastBuild;

    if (withinTtl || sameBuild) {
      // Не перезагружаем повторно
       
      console.log('[SafeReload] Skipped:', { reason, build, withinTtl, sameBuild });
      return;
    }

    sessionStorage.setItem(KEY_TS, String(now));
    if (build) sessionStorage.setItem(KEY_BUILD, build);

     
    console.log('[SafeReload] Reloading:', { reason, build });
    window.location.reload();
  } catch (e) {
    // На всякий случай — не ломаем UX при отказе sessionStorage
     
    console.log('[SafeReload] Fallback reload:', { reason, build, error: String(e) });
    window.location.reload();
  }
}
